module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-f"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_ListMaps"
    }
  }, [_vm._v("List of Maps")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-f"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Editors"
    }
  }, [_vm._v("Series Editor’s Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-f"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-f"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")]), _c('span', {
    staticClass: "space-1"
  }, [_vm._v("The Somme Battle 1916: September to the Battle’s End")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")]), _c('span', {
    staticClass: "space-1"
  }, [_vm._v("Mid-September success – Martinpuich is taken")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")]), _c('span', {
    staticClass: "space-1"
  }, [_vm._v("Early October: Eaucourt l’Abbaye is taken")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")]), _c('span', {
    staticClass: "space-1"
  }, [_vm._v("The Advance from Eaucourt l’Abbaye to the capture of Le Sars on 8 October")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")]), _c('span', {
    staticClass: "space-1"
  }, [_vm._v("The further attempts to capture the Butte de Warlencourt: October and November 1916")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Guide",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Guide to the Book and to Visiting the Battlefields")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-b"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15_Tour1"
    }
  }, [_vm._v("Walking Tour 1"), _c('span', {
    staticClass: "space-1"
  }, [_vm._v("The area around the Butte de Warlencourt")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-b"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/16_Tour2"
    }
  }, [_vm._v("Walking Tour 2"), _c('span', {
    staticClass: "space-1"
  }, [_vm._v("Martinpuich and Area")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Touring",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Touring the area by vehicle: Behind the German Lines")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Reading and Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14c103a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0